import { render } from "./BackerCenterPledgesSection.vue?vue&type=template&id=3523486a"
import script from "./BackerCenterPledgesSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__